import { format, addDays, subDays } from 'date-fns';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface DateNavigatorProps {
  date: string; // yyyy-MM-dd format
  onChange: (date: string) => void;
  className?: string;
}

export function DateNavigator({ date, onChange, className }: DateNavigatorProps) {
  const currentDate = new Date(date);

  const handlePrev = () => {
    onChange(format(subDays(currentDate, 1), 'yyyy-MM-dd'));
  };

  const handleNext = () => {
    onChange(format(addDays(currentDate, 1), 'yyyy-MM-dd'));
  };

  return (
    <div className={`flex items-center gap-1 ${className || ''}`}>
      <Button
        type="button"
        variant="outline"
        size="icon"
        className="h-10 w-10"
        onClick={handlePrev}
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <input
        type="date"
        value={date}
        onChange={(e) => onChange(e.target.value)}
        className="h-10 px-3 rounded-md border border-input bg-background text-sm"
      />
      <Button
        type="button"
        variant="outline"
        size="icon"
        className="h-10 w-10"
        onClick={handleNext}
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
}
